import './index.css';
import "./index.css";
import React from "react";
import { render } from "react-dom";
import { App } from "./App";
render(<App data-id="element-677" data-mp="1wc5y0cckn6oi" />, document.getElementById("root"));